// Estilos de la experiencia Mobile (M.1). Todo va bajo el prefijo .m- para no
// colisionar con ESTILOS (Desktop), que además no se inyecta en Mobile.
// Paleta tomada de la identidad existente: --primary #1d3d6b, --secondary #0086ab,
// --accent #3cafd6 y el degradado navy del sidebar Desktop.

export const ESTILOS_MOBILE = `
  .m-root {
    --m-primary: #1d3d6b;
    --m-primary-dark: #152d52;
    --m-secondary: #0086ab;
    --m-accent: #3cafd6;
    --m-bg: #f3f6f9;
    --m-surface: #ffffff;
    --m-border: #e3e8ef;
    --m-text: #1a2b42;
    --m-muted: #5f6b7a;
    --m-soft: #e6f4f8;
    --m-header-h: 56px;
    --m-nav-h: 64px;
    --m-safe-top: env(safe-area-inset-top, 0px);
    --m-safe-bottom: env(safe-area-inset-bottom, 0px);
    --m-safe-left: env(safe-area-inset-left, 0px);
    --m-safe-right: env(safe-area-inset-right, 0px);

    min-height: 100vh;
    min-height: 100dvh;
    background: var(--m-bg);
    color: var(--m-text);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
    overflow-x: hidden;
  }
  .m-root *, .m-root *::before, .m-root *::after { box-sizing: border-box; }
  /* :where() = especificidad 0, para no pisar el color de .m-btn-*, .m-nav-btn, etc. */
  :where(.m-root) button { font: inherit; color: inherit; }
  /* >=16px evita el zoom automático de iOS al enfocar campos (para etapas futuras) */
  .m-root input, .m-root select, .m-root textarea { font-size: 16px; }
  .m-root :focus-visible { outline: 3px solid var(--m-accent); outline-offset: 2px; }

  /* ───────────── Login ───────────── */
  /* Hero y hoja comparten el mismo eje central; la acción principal (Google)
     queda arriba de la mitad de la pantalla en 390×844. */
  .m-login { display: flex; flex-direction: column; }
  .m-login-hero {
    position: relative; overflow: hidden; color: white; text-align: center;
    background: linear-gradient(160deg, var(--m-primary-dark) 0%, var(--m-primary) 45%, var(--m-secondary) 100%);
    padding: calc(28px + var(--m-safe-top)) 24px 48px;
  }
  .m-login-hero::before, .m-login-hero::after {
    content: ''; position: absolute; border-radius: 50%; pointer-events: none;
  }
  .m-login-hero::before { width: 200px; height: 200px; border: 40px solid rgba(255,255,255,0.06); top: -90px; left: -70px; }
  .m-login-hero::after { width: 150px; height: 150px; border: 30px solid rgba(255,255,255,0.05); bottom: -50px; right: -50px; }
  .m-login-logo {
    position: relative; width: 76px; height: 76px; margin: 0 auto 14px; padding: 5px;
    border-radius: 18px; background: white; box-shadow: 0 6px 24px rgba(0,0,0,0.18);
    display: flex; align-items: center; justify-content: center;
  }
  .m-login-logo img { width: 100%; height: 100%; object-fit: contain; }
  .m-login-empresa { position: relative; font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; opacity: 0.75; margin-bottom: 4px; }
  .m-login-marca { position: relative; font-size: 32px; font-weight: 800; letter-spacing: -1px; line-height: 1.05; margin: 0 0 6px; }
  .m-login-sub { position: relative; font-size: 14px; opacity: 0.85; margin: 0; }

  .m-login-sheet {
    position: relative; flex: 1; margin-top: -24px; background: var(--m-bg);
    border-radius: 24px 24px 0 0;
    padding: 26px calc(20px + var(--m-safe-right)) calc(24px + var(--m-safe-bottom)) calc(20px + var(--m-safe-left));
  }
  .m-login-inner { width: 100%; max-width: 400px; margin: 0 auto; text-align: center; }
  .m-login-titulo { font-size: 22px; font-weight: 700; color: var(--m-primary); margin: 0 0 6px; }
  .m-login-texto { font-size: 15px; line-height: 1.45; color: var(--m-muted); margin: 0 auto 20px; max-width: 300px; }
  .m-login-card { background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 18px; padding: 20px 16px 16px; box-shadow: 0 4px 18px rgba(16,42,77,0.07); }
  .m-login-google { display: flex; justify-content: center; min-height: 44px; overflow: hidden; }
  .m-login-verificando { display: flex; align-items: center; justify-content: center; gap: 10px; min-height: 44px; font-size: 15px; color: var(--m-muted); }
  .m-login-nota { display: flex; align-items: center; justify-content: center; gap: 6px; margin: 14px 0 0; font-size: 13px; color: var(--m-muted); }
  .m-login-nota i { font-size: 16px; flex-shrink: 0; }
  .m-login-error { margin-top: 14px; display: flex; gap: 8px; align-items: flex-start; text-align: left; background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; border-radius: 12px; padding: 12px; font-size: 14px; font-weight: 600; line-height: 1.4; overflow-wrap: anywhere; }
  .m-login-error i { font-size: 18px; flex-shrink: 0; }
  .m-login-ayuda { margin: 20px 0 0; font-size: 13px; color: #8a94a3; }

  /* ───────────── Shell ───────────── */
  .m-header {
    position: sticky; top: 0; z-index: 20; color: white;
    background: linear-gradient(135deg, var(--m-primary-dark) 0%, var(--m-primary) 100%);
    padding: var(--m-safe-top) calc(12px + var(--m-safe-right)) 0 calc(16px + var(--m-safe-left));
    box-shadow: 0 2px 10px rgba(16,42,77,0.18);
  }
  .m-header-row { height: var(--m-header-h); display: flex; align-items: center; gap: 12px; }
  /* El emblema es circular: contenedor circular con aire alrededor del aro */
  .m-header-logo { width: 38px; height: 38px; border-radius: 50%; background: white; padding: 3px; flex-shrink: 0; box-shadow: 0 0 0 2px rgba(255,255,255,0.15); }
  .m-header-logo img { width: 100%; height: 100%; object-fit: contain; display: block; border-radius: 50%; }
  .m-header-marca { flex: 1; min-width: 0; line-height: 1.15; }
  .m-header-nombre { font-size: 18px; font-weight: 800; letter-spacing: -0.3px; }
  .m-header-empresa { font-size: 11px; opacity: 0.7; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .m-avatar-btn {
    width: 44px; height: 44px; flex-shrink: 0; border: none; background: transparent; padding: 0; cursor: pointer;
    display: flex; align-items: center; justify-content: center; border-radius: 50%;
  }
  .m-avatar {
    width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
    background: linear-gradient(135deg, var(--m-secondary), var(--m-accent)); color: white;
    font-weight: 700; font-size: 15px; box-shadow: 0 0 0 2px rgba(60,175,214,0.45); text-transform: uppercase;
  }
  .m-avatar.lg { width: 48px; height: 48px; font-size: 20px; flex-shrink: 0; }

  .m-main {
    padding: 16px calc(16px + var(--m-safe-right)) calc(var(--m-nav-h) + var(--m-safe-bottom) + 24px) calc(16px + var(--m-safe-left));
    max-width: 640px; margin: 0 auto;
  }

  /* Barra inferior: 5 columnas iguales que sólo se ensanchan si una etiqueta
     lo necesita (1fr = minmax(auto, 1fr)); así ninguna etiqueta se trunca en 320px. */
  .m-nav {
    position: fixed; left: 0; right: 0; bottom: 0; z-index: 30;
    background: rgba(255,255,255,0.97); border-top: 1px solid var(--m-border);
    box-shadow: 0 -4px 16px rgba(16,42,77,0.06);
    padding: 0 var(--m-safe-right) var(--m-safe-bottom) var(--m-safe-left);
  }
  .m-nav ul { list-style: none; margin: 0 auto; padding: 0 2px; display: grid; grid-template-columns: repeat(5, 1fr); max-width: 640px; height: var(--m-nav-h); }
  .m-nav-btn {
    width: 100%; height: 100%; border: none; background: none; cursor: pointer;
    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px;
    color: var(--m-muted); font-size: 12px; font-weight: 500; padding: 6px 1px;
  }
  /* width:100% + max-width: la píldora no impone ancho mínimo a la columna */
  .m-nav-icono { width: 100%; max-width: 56px; height: 30px; border-radius: 15px; display: flex; align-items: center; justify-content: center; transition: background 0.15s; }
  .m-nav-icono i { font-size: 22px; }
  .m-nav-label { max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  /* Reserva el ancho en negrita: la pestaña activa no cambia de tamaño ni se trunca */
  .m-nav-label::after { content: attr(data-label); display: block; height: 0; overflow: hidden; visibility: hidden; font-weight: 700; }
  .m-nav-btn[aria-current="page"] { color: var(--m-secondary); font-weight: 700; }
  .m-nav-btn[aria-current="page"] .m-nav-icono { background: var(--m-soft); }
  .m-nav-btn:active .m-nav-icono { background: #d5ecf3; }
  @media (max-width: 359.98px) { .m-nav-btn { font-size: 11px; } }

  /* ───────────── Inicio ───────────── */
  .m-bienvenida {
    position: relative; overflow: hidden; border-radius: 20px; padding: 22px 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #ffffff 55%, var(--m-soft) 100%);
    border: 1px solid var(--m-border); box-shadow: 0 2px 10px rgba(16,42,77,0.05);
  }
  .m-bienvenida::before { content: ''; position: absolute; left: 0; top: 20px; bottom: 20px; width: 4px; border-radius: 0 4px 4px 0; background: linear-gradient(180deg, var(--m-secondary), var(--m-accent)); }
  .m-bienvenida-marca { position: absolute; right: -28px; bottom: -28px; width: 132px; height: 132px; opacity: 0.1; pointer-events: none; mix-blend-mode: multiply; }
  .m-bienvenida > *:not(.m-bienvenida-marca) { position: relative; }
  .m-fecha { margin: 0 0 6px; font-size: 13px; font-weight: 600; color: var(--m-secondary); }
  .m-fecha::first-letter { text-transform: uppercase; }
  .m-saludo { margin: 0 0 6px; font-size: 24px; font-weight: 700; color: var(--m-primary); line-height: 1.2; overflow-wrap: anywhere; padding-right: 48px; }
  .m-bienvenida-sub { margin: 0; font-size: 14px; color: var(--m-muted); padding-right: 48px; }

  .m-chip { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 700; letter-spacing: 0.02em; padding: 3px 8px; border-radius: 999px; background: #fff4e0; color: #92560a; white-space: nowrap; }

  /* Placeholder de módulos aún no disponibles */
  .m-placeholder { text-align: center; padding: 28px 8px 8px; }
  .m-placeholder-icono { width: 88px; height: 88px; margin: 0 auto 20px; border-radius: 28px; display: flex; align-items: center; justify-content: center; font-size: 44px; background: var(--m-soft); color: var(--m-secondary); }
  .m-placeholder h1 { margin: 12px 0 10px; font-size: 22px; font-weight: 700; color: var(--m-primary); line-height: 1.25; }
  .m-placeholder p { margin: 0 auto 28px; max-width: 340px; font-size: 15px; line-height: 1.5; color: var(--m-muted); }
  .m-btn {
    display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 48px;
    padding: 0 22px; border-radius: 14px; border: none; cursor: pointer; font-size: 16px; font-weight: 600;
  }
  .m-btn-primario { background: var(--m-primary); color: white; box-shadow: 0 4px 12px rgba(29,61,107,0.25); }
  .m-btn-primario:active { background: var(--m-primary-dark); }
  .m-btn-bloque { width: 100%; }
  .m-btn-peligro { background: white; color: #c53030; border: 1px solid #f3c4c4; }
  .m-btn-peligro:active { background: #fef2f2; }

  /* Más / cuenta */
  .m-titulo-pagina { margin: 0 0 16px; font-size: 22px; font-weight: 700; color: var(--m-primary); }
  .m-cuenta { display: flex; align-items: center; gap: 14px; background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 16px; padding: 16px; margin-bottom: 20px; }
  .m-cuenta-datos { min-width: 0; flex: 1; }
  .m-cuenta-nombre { font-size: 17px; font-weight: 700; overflow-wrap: anywhere; }
  .m-cuenta-email { font-size: 14px; color: var(--m-muted); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .m-cuenta .m-chip { margin-top: 6px; background: #eef1f4; color: #4b5563; }
  .m-pie { margin: 24px 0 0; text-align: center; font-size: 12px; color: #8a94a3; line-height: 1.5; }

  /* ───────────── Utilidades compartidas ───────────── */
  .m-sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }
  .m-btn-secundario { background: var(--m-surface); color: var(--m-primary); border: 1px solid var(--m-border); min-height: 44px; font-size: 15px; padding: 0 16px; }
  .m-btn-secundario:active { background: var(--m-soft); }
  .m-volver {
    display: inline-flex; align-items: center; gap: 6px; min-height: 44px; margin: -6px 0 6px -8px; padding: 0 8px;
    border: none; background: none; cursor: pointer; color: var(--m-secondary); font-size: 16px; font-weight: 600; border-radius: 10px;
  }
  .m-volver i { font-size: 20px; }

  /* Estatus (mismos colores que los badges del expediente Desktop) */
  .m-estatus { display: inline-flex; align-items: center; gap: 5px; font-size: 13px; font-weight: 600; white-space: nowrap; }
  .m-estatus-punto { width: 8px; height: 8px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
  .m-estatus-activo { color: #0f9f6e; }
  .m-estatus-baja { color: #dc2626; }
  .m-estatus-neutro { color: #64748b; }

  /* ───────────── Empleados: lista ───────────── */
  .m-emp .m-titulo-pagina { margin-bottom: 12px; }
  /* Buscador + chips quedan a la mano al hacer scroll (debajo del header) */
  .m-emp-barra {
    position: sticky; top: calc(var(--m-header-h) + var(--m-safe-top)); z-index: 10;
    margin: 0 -16px 14px; padding: 4px 16px 12px; background: var(--m-bg);
  }
  .m-buscador {
    position: relative; display: flex; align-items: center; height: 52px; padding: 0 6px 0 16px; gap: 10px;
    background: var(--m-surface); border: 1.5px solid var(--m-border); border-radius: 16px;
    box-shadow: 0 2px 10px rgba(16,42,77,0.06); transition: border-color 0.15s, box-shadow 0.15s;
  }
  .m-buscador:focus-within { border-color: var(--m-secondary); box-shadow: 0 0 0 4px rgba(0,134,171,0.12); }
  .m-buscador > .ti-search { font-size: 21px; color: var(--m-secondary); flex-shrink: 0; }
  .m-buscador input {
    flex: 1; min-width: 0; height: 100%; border: none; outline: none; background: transparent;
    color: var(--m-text); font-family: inherit; font-size: 16px; -webkit-appearance: none; appearance: none;
  }
  .m-buscador input::placeholder { color: #8a94a3; }
  /* El texto escrito se queda en 16px (evita zoom de iOS); sólo el placeholder se ajusta en 320px */
  @media (max-width: 359.98px) { .m-buscador input::placeholder { font-size: 14px; } }
  .m-buscador input::-webkit-search-cancel-button { display: none; }
  .m-root .m-buscador input:focus-visible { outline: none; }
  .m-buscador-limpiar {
    width: 40px; height: 40px; flex-shrink: 0; border: none; border-radius: 12px; background: #eef2f6;
    color: var(--m-muted); display: flex; align-items: center; justify-content: center; cursor: pointer;
  }
  .m-buscador-limpiar i { font-size: 18px; }

  /* Contador discreto de activos, bajo el buscador */
  .m-emp-contador { margin: 8px 2px 0; font-size: 13px; font-weight: 600; color: var(--m-muted); }

  .m-emp-lista { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
  .m-emp-card {
    width: 100%; display: flex; align-items: center; gap: 14px; padding: 14px 12px 14px 14px; min-height: 76px;
    background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 16px; text-align: left; cursor: pointer;
    box-shadow: 0 1px 3px rgba(16,42,77,0.04); transition: transform 0.12s, background 0.12s;
  }
  .m-emp-card:active { transform: scale(0.985); background: #f8fafc; }
  .m-emp-avatar {
    width: 46px; height: 46px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;
    font-size: 16px; font-weight: 700; letter-spacing: 0.02em; color: white;
    background: linear-gradient(135deg, #1d3d6b 0%, #0a6f9a 70%, #1fb1d6 100%);
  }
  .m-emp-avatar.m-tono-baja { background: linear-gradient(135deg, #7f1d1d, #dc2626); }
  .m-emp-avatar.m-tono-neutro { background: linear-gradient(135deg, #475569, #94a3b8); }
  .m-emp-cuerpo { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
  .m-emp-nombre {
    font-size: 16px; font-weight: 700; color: var(--m-text); line-height: 1.25; overflow-wrap: anywhere;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
  }
  .m-emp-meta { display: flex; align-items: center; flex-wrap: wrap; gap: 2px 10px; }
  .m-emp-num { font-size: 13px; font-weight: 700; color: var(--m-primary); font-variant-numeric: tabular-nums; }
  .m-emp-puesto { font-size: 14px; color: var(--m-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .m-emp-chev { font-size: 20px; color: #a3adba; flex-shrink: 0; }

  .m-emp-esqueleto { height: 76px; border-radius: 16px; background: var(--m-surface); border: 1px solid var(--m-border); display: flex; flex-direction: column; justify-content: center; gap: 10px; padding: 0 16px 0 74px; position: relative; }
  .m-emp-esqueleto::before { content: ''; position: absolute; left: 14px; top: 15px; width: 46px; height: 46px; border-radius: 50%; }
  .m-emp-esqueleto::before, .m-emp-esqueleto span { background: linear-gradient(90deg, #eef2f6 0%, #f6f8fb 50%, #eef2f6 100%); background-size: 200% 100%; animation: m-brillo 1.3s ease-in-out infinite; }
  .m-emp-esqueleto span { display: block; height: 12px; border-radius: 6px; width: 70%; }
  .m-emp-esqueleto span + span { width: 45%; }
  @keyframes m-brillo { from { background-position: 100% 0; } to { background-position: -100% 0; } }
  @media (prefers-reduced-motion: reduce) { .m-emp-esqueleto::before, .m-emp-esqueleto span { animation: none; } }

  .m-emp-vacio { text-align: center; padding: 36px 12px 12px; color: var(--m-muted); }
  .m-emp-vacio > i { font-size: 34px; color: #a3adba; }
  .m-emp-vacio-titulo { margin: 10px 0 4px; font-size: 16px; font-weight: 700; color: var(--m-text); }
  .m-emp-vacio-texto { margin: 0; font-size: 14px; line-height: 1.45; }
  .m-emp-vacio-acciones { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 18px; }

  /* ───────────── Empleados: credencial compacta (M.2A.1) ───────────── */
  /* Cabecera del futuro expediente Mobile: mismo degradado que el header del
     expediente Desktop, identidad en horizontal para no ocupar la pantalla. */
  .m-cred {
    position: relative; overflow: hidden; color: white;
    padding: 18px 18px 16px; border-radius: 20px;
    background: linear-gradient(125deg, #0f2a52 0%, #1d3d6b 38%, #0a6f9a 72%, #1fb1d6 100%);
    box-shadow: 0 8px 22px rgba(15,42,82,0.24);
  }
  .m-cred::before, .m-cred::after { content: ''; position: absolute; border-radius: 50%; pointer-events: none; }
  .m-cred::before { width: 180px; height: 180px; border: 32px solid rgba(255,255,255,0.05); top: -96px; right: -64px; }
  .m-cred::after { width: 120px; height: 120px; border: 22px solid rgba(255,255,255,0.05); bottom: -64px; right: 40px; }
  .m-cred > * { position: relative; }
  .m-cred-id { display: flex; align-items: flex-start; gap: 14px; }
  .m-cred-avatar {
    width: 58px; height: 58px; flex-shrink: 0; border-radius: 50%; display: flex; align-items: center; justify-content: center;
    font-size: 21px; font-weight: 700; letter-spacing: 0.02em; background: rgba(255,255,255,0.18);
    box-shadow: 0 0 0 3px rgba(255,255,255,0.28);
  }
  .m-cred-ident { flex: 1; min-width: 0; padding-top: 2px; }
  .m-cred-nombre { margin: 0 0 8px; font-size: 18px; font-weight: 800; line-height: 1.22; letter-spacing: 0.01em; overflow-wrap: anywhere; }
  .m-cred-linea { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 10px; }
  .m-cred-num { font-size: 17px; font-weight: 800; line-height: 1; font-variant-numeric: tabular-nums; }
  .m-cred-badge { display: inline-flex; align-items: center; gap: 6px; padding: 4px 11px; border-radius: 999px; font-size: 13px; font-weight: 700; color: white; }
  .m-cred-badge .m-estatus-punto { background: white; }
  .m-cred-badge-activo { background: #10b981; }
  .m-cred-badge-baja { background: #ef4444; }
  .m-cred-badge-neutro { background: #64748b; }
  .m-cred-laboral { margin: 14px 0 0; padding-top: 12px; border-top: 1px solid rgba(255,255,255,0.16); }
  .m-cred-laboral dd { margin: 0; overflow-wrap: anywhere; }
  .m-cred-puesto dd { font-size: 16px; font-weight: 700; line-height: 1.3; }
  .m-cred-ubicacion dd { margin-top: 2px; font-size: 14px; line-height: 1.35; opacity: 0.85; }

  /* ───────────── Expediente Mobile (M.2B) ───────────── */
  .m-cred-avatar-foto { overflow: hidden; background: white; }
  .m-cred-avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }

  .m-exp-bloque { margin-top: 20px; }
  .m-exp-titulo { margin: 0 0 10px 2px; font-size: 13px; font-weight: 700; color: var(--m-muted); text-transform: uppercase; letter-spacing: 0.06em; }

  /* Información rápida compacta (M.2B.1): una franja ligera con tinte cian,
     pares etiqueta/valor sin divisiones ni íconos por dato, y el teléfono
     como una sola fila tocable. */
  .m-rapida {
    padding: 14px 16px; border-radius: 16px;
    background: linear-gradient(180deg, #eef7fb 0%, #f5fafd 100%); border: 1px solid #d9ecf4;
  }
  .m-rapida-datos { margin: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 16px; }
  .m-rapida-dato { min-width: 0; }
  .m-rapida-dato dt { font-size: 12px; font-weight: 600; color: var(--m-muted); margin-bottom: 1px; }
  .m-rapida-dato dd { margin: 0; font-size: 15px; font-weight: 700; color: var(--m-text); line-height: 1.25; overflow-wrap: anywhere; }
  .m-rapida-tel {
    display: flex; align-items: center; gap: 10px; min-height: 44px; margin-top: 12px; padding-top: 10px;
    border-top: 1px solid #d9ecf4; color: var(--m-secondary); text-decoration: none;
  }
  .m-rapida-datos:empty + .m-rapida-tel, .m-rapida > .m-rapida-tel:first-child { margin-top: 0; padding-top: 0; border-top: none; }
  .m-rapida-tel > i { font-size: 19px; flex-shrink: 0; }
  .m-rapida-tel-numero { flex: 1; min-width: 0; font-size: 16px; font-weight: 700; white-space: nowrap; }
  .m-rapida-llamar { flex-shrink: 0; padding: 6px 14px; border-radius: 999px; background: var(--m-secondary); color: white; font-size: 13px; font-weight: 700; }
  .m-rapida-tel:active .m-rapida-llamar { background: var(--m-primary); }
  .m-rapida-cargando .m-rapida-dato span { display: block; height: 10px; border-radius: 5px; width: 50%; margin-bottom: 7px; background: linear-gradient(90deg, #dde9f0 0%, #eef5f9 50%, #dde9f0 100%); background-size: 200% 100%; animation: m-brillo 1.3s ease-in-out infinite; }
  .m-rapida-cargando .m-rapida-dato span + span { width: 75%; height: 14px; margin-bottom: 0; }
  @media (prefers-reduced-motion: reduce) { .m-rapida-cargando .m-rapida-dato span, .m-sec-esqueleto span { animation: none; } }

  .m-exp-error {
    display: flex; align-items: center; flex-wrap: wrap; gap: 8px 10px; padding: 12px 14px;
    background: #fff7ed; border: 1px solid #fed7aa; border-radius: 14px; color: #9a3412; font-size: 14px; line-height: 1.35;
  }
  .m-exp-error > i { font-size: 19px; flex-shrink: 0; }
  .m-exp-error > span { flex: 1; min-width: 150px; }
  .m-exp-reintentar {
    min-height: 40px; padding: 0 14px; border-radius: 10px; border: 1px solid #fdba74; background: white;
    color: #9a3412; font-size: 14px; font-weight: 700; cursor: pointer;
  }

  /* Entradas del expediente */
  .m-exp-lista { list-style: none; margin: 0; padding: 0; background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 16px; overflow: hidden; }
  .m-exp-lista li + li { border-top: 1px solid #eef2f6; }
  .m-exp-entrada { width: 100%; display: flex; align-items: center; gap: 12px; min-height: 60px; padding: 10px 12px 10px 14px; border: none; background: none; text-align: left; cursor: pointer; }
  .m-exp-entrada:active { background: #f8fafc; }
  .m-exp-entrada-icono { width: 36px; height: 36px; flex-shrink: 0; border-radius: 10px; background: #e8eef7; color: var(--m-primary); display: flex; align-items: center; justify-content: center; font-size: 19px; }
  .m-exp-entrada-texto { flex: 1; min-width: 0; display: flex; flex-direction: column; }
  .m-exp-entrada-titulo { font-size: 16px; font-weight: 700; color: var(--m-text); }
  .m-exp-entrada-desc { font-size: 13px; color: var(--m-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  /* Subvistas */
  .m-exp-seccion-titulo { margin-bottom: 2px; }
  .m-exp-contexto { margin: 0 0 16px; font-size: 13px; font-weight: 600; color: var(--m-muted); overflow-wrap: anywhere; }
  .m-sec-grupo + .m-sec-grupo { margin-top: 20px; }
  .m-sec-lista { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
  .m-sec-item { background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 16px; padding: 14px; }
  .m-sec-item-cabecera { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
  .m-sec-item-titulo { font-size: 16px; font-weight: 700; color: var(--m-text); line-height: 1.3; overflow-wrap: anywhere; min-width: 0; }
  .m-sec-chip { flex-shrink: 0; padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: 700; white-space: nowrap; }
  .m-sec-chip-pendiente { background: #fff4e0; color: #92560a; }
  .m-sec-chip-confirmado { background: #dcfce7; color: #166534; }
  .m-sec-chip-neutro { background: #eef1f4; color: #4b5563; }
  .m-sec-meta { margin: 4px 0 0; font-size: 14px; color: var(--m-muted); line-height: 1.35; overflow-wrap: anywhere; }
  .m-sec-nota { display: flex; align-items: center; gap: 6px; margin: 10px 0 0; font-size: 14px; color: var(--m-muted); }
  .m-sec-grupo > .m-sec-nota { margin-top: 0; padding: 14px; background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 16px; }

  .m-cambio-valores { display: flex; align-items: stretch; gap: 8px; margin: 12px 0 0; }
  .m-cambio-valores > div { flex: 1; min-width: 0; padding: 8px 10px; border-radius: 10px; background: #f6f8fb; }
  .m-cambio-nuevo { background: var(--m-soft) !important; }
  .m-cambio-valores dt { font-size: 11px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--m-muted); margin-bottom: 2px; }
  .m-cambio-valores dd { margin: 0; font-size: 14px; font-weight: 600; color: var(--m-text); overflow-wrap: anywhere; }
  .m-cambio-flecha { align-self: center; color: #a3adba; font-size: 16px; flex-shrink: 0; }


  .m-doc-lista { list-style: none; margin: 0; padding: 0; background: var(--m-surface); border: 1px solid var(--m-border); border-radius: 16px; overflow: hidden; }
  .m-doc-lista li + li { border-top: 1px solid #eef2f6; }
  .m-doc { display: flex; align-items: center; gap: 12px; min-height: 60px; padding: 10px 14px; color: inherit; text-decoration: none; }
  a.m-doc:active { background: #f8fafc; }
  .m-doc-icono { width: 36px; height: 36px; flex-shrink: 0; border-radius: 10px; background: #e4f1f8; color: var(--m-secondary); display: flex; align-items: center; justify-content: center; font-size: 19px; }
  .m-doc-texto { flex: 1; min-width: 0; display: flex; flex-direction: column; }
  .m-doc-titulo { font-size: 15px; font-weight: 700; color: var(--m-text); line-height: 1.3; overflow-wrap: anywhere; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .m-doc-meta { font-size: 13px; color: var(--m-muted); }
  .m-doc-abrir { font-size: 18px; color: var(--m-secondary); flex-shrink: 0; }

  .m-sec-cargando { display: flex; flex-direction: column; gap: 10px; }
  .m-sec-esqueleto { height: 72px; border-radius: 16px; background: var(--m-surface); border: 1px solid var(--m-border); display: flex; flex-direction: column; justify-content: center; gap: 10px; padding: 0 16px; }
  .m-sec-esqueleto span { display: block; height: 12px; border-radius: 6px; width: 65%; background: linear-gradient(90deg, #eef2f6 0%, #f6f8fb 50%, #eef2f6 100%); background-size: 200% 100%; animation: m-brillo 1.3s ease-in-out infinite; }
  .m-sec-esqueleto span + span { width: 40%; }

  /* ───────────── Carga documental Mobile (M.2B.2) ───────────── */
  .m-sec-intro { margin: -6px 0 12px; font-size: 14px; color: var(--m-muted); }
  .m-carga { margin-bottom: 20px; }
  .m-carga-acciones { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .m-carga-accion {
    display: flex; align-items: center; justify-content: center; gap: 8px; min-height: 52px; padding: 0 10px;
    border-radius: 14px; border: 1px solid #cfe6f0; background: var(--m-surface); color: var(--m-primary);
    font-size: 15px; font-weight: 700; cursor: pointer; box-shadow: 0 1px 3px rgba(16,42,77,0.05);
  }
  .m-carga-accion i { font-size: 21px; color: var(--m-secondary); }
  .m-carga-accion:active { background: var(--m-soft); }
  .m-carga-accion:disabled { opacity: 0.45; cursor: default; }

  .m-carga-aviso { display: flex; align-items: flex-start; gap: 8px; margin: 12px 0 0; padding: 10px 12px; border-radius: 12px; font-size: 14px; line-height: 1.4; }
  .m-carga-aviso > i { font-size: 18px; flex-shrink: 0; margin-top: 1px; }
  .m-carga-aviso-exito { background: #dcfce7; color: #166534; }
  .m-carga-aviso-error { background: #fff7ed; color: #9a3412; border: 1px solid #fed7aa; }
  .m-carga-aviso-info { background: var(--m-soft); color: #0b5d78; }

  .m-carga-panel { margin-top: 12px; padding: 14px; border-radius: 16px; background: var(--m-surface); border: 1px solid var(--m-border); box-shadow: 0 2px 10px rgba(16,42,77,0.06); }
  .m-carga-archivo { display: flex; align-items: center; gap: 12px; }
  .m-carga-preview { width: 84px; height: 84px; flex-shrink: 0; border-radius: 12px; object-fit: cover; background: #eef2f6; border: 1px solid var(--m-border); }
  .m-carga-icono { width: 56px; height: 56px; flex-shrink: 0; border-radius: 14px; background: #e4f1f8; color: var(--m-secondary); display: flex; align-items: center; justify-content: center; font-size: 28px; }
  .m-carga-info { margin: 0; flex: 1; min-width: 0; font-size: 13px; color: var(--m-muted); line-height: 1.4; }
  .m-carga-info dd { margin: 0; overflow-wrap: anywhere; }
  .m-carga-nombre { font-size: 15px; font-weight: 700; color: var(--m-text); }
  .m-carga-destino { margin: 12px 0 0; font-size: 14px; color: var(--m-muted); line-height: 1.4; overflow-wrap: anywhere; }
  .m-carga-destino strong { color: var(--m-text); }
  .m-carga-botones { display: flex; gap: 10px; margin-top: 14px; }
  .m-carga-botones .m-btn { flex: 1; min-width: 0; padding: 0 12px; }
  .m-carga-cancelar { display: block; margin: 8px auto 0; min-height: 44px; padding: 0 16px; border: none; background: none; color: var(--m-muted); font-size: 15px; font-weight: 600; cursor: pointer; }
  .m-carga-estado { display: flex; align-items: center; gap: 8px; margin: 12px 0 0; font-size: 15px; font-weight: 600; color: var(--m-secondary); }
  .m-carga-panel > .m-carga-estado:first-child { margin-top: 0; }
  .m-girando { display: inline-block; animation: m-girar 1s linear infinite; }
  @keyframes m-girar { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: reduce) { .m-girando { animation: none; } }

  .m-dialogo-fondo {
    position: fixed; inset: 0; z-index: 50; display: flex; align-items: flex-end; justify-content: center;
    padding: 16px calc(16px + var(--m-safe-right)) calc(16px + var(--m-safe-bottom)) calc(16px + var(--m-safe-left));
    background: rgba(15, 23, 42, 0.45);
  }
  .m-dialogo { width: 100%; max-width: 440px; padding: 20px; border-radius: 20px; background: var(--m-surface); box-shadow: 0 12px 32px rgba(15,23,42,0.25); }
  .m-dialogo h2 { margin: 0 0 8px; font-size: 18px; font-weight: 800; color: var(--m-primary); }
  .m-dialogo p { margin: 0; font-size: 15px; line-height: 1.45; color: var(--m-muted); }

  /* ───────────── Registro de capacitación Mobile (M.2B.3) ───────────── */
  .m-registro-abrir { width: 100%; }
  .m-registro-form { margin-top: 0; margin-bottom: 20px; }
  .m-registro-titulo { margin: 0 0 14px; font-size: 17px; font-weight: 800; color: var(--m-primary); }
  .m-campo { display: flex; flex-direction: column; gap: 6px; margin-bottom: 16px; min-width: 0; }
  .m-campo-etiqueta { font-size: 13px; font-weight: 700; color: var(--m-muted); }
  .m-campo-control {
    width: 100%; min-width: 0; min-height: 48px; padding: 0 12px; border-radius: 12px;
    border: 1.5px solid var(--m-border); background: var(--m-surface); color: var(--m-text);
    font-family: inherit; font-size: 16px;
  }
  .m-campo-control:focus { outline: none; border-color: var(--m-secondary); box-shadow: 0 0 0 3px rgba(0,134,171,0.14); }
  .m-campo-control:disabled { background: #f6f8fb; color: var(--m-muted); }
  select.m-campo-control { text-overflow: ellipsis; }
  .m-campo-ayuda { font-size: 13px; color: var(--m-muted); line-height: 1.4; overflow-wrap: anywhere; }
  .m-campo-error { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; font-size: 13px; font-weight: 600; color: #b91c1c; }
  .m-registro-participante { margin: 0; padding: 10px 12px; border-radius: 12px; background: #f6f8fb; border: 1px solid var(--m-border); font-size: 15px; color: var(--m-text); overflow-wrap: anywhere; }
  .m-registro-quitar { margin: 4px 0 0; }
  /* Registros atribuibles al empleado (M.2B.4): bloque compacto dentro de la tarjeta del curso */
  .m-reg-propios { margin-top: 12px; padding-top: 10px; border-top: 1px solid #eef2f6; }
  .m-reg-titulo { margin: 0 0 4px; font-size: 11px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: var(--m-muted); }
  .m-reg-lista { list-style: none; margin: 0; padding: 0; }
  .m-reg-fila { display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 44px; }
  .m-reg-fila + .m-reg-fila { border-top: 1px dashed #e6ebf1; }
  .m-reg-fecha { font-size: 15px; font-weight: 700; color: var(--m-text); }
  .m-reg-ver { display: inline-flex; align-items: center; gap: 4px; min-height: 44px; padding: 0 2px; color: var(--m-secondary); font-size: 14px; font-weight: 700; text-decoration: none; white-space: nowrap; }
  /* En pantallas angostas la accion principal va arriba y a todo lo ancho */
  @media (max-width: 359.98px) { .m-registro-form .m-carga-botones { flex-direction: column-reverse; } }
`;
